import { SettingsParser } from "./settings-parser";
import { UnitSettings } from "../settings/unit-settings";

export class UnitSettingsParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = ["id", "text", "scale"];
  }

  static createSettings(settings) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {};
    parsedSettings.id = settings.id;
    parsedSettings.text = settings.text;
    parsedSettings.scale = settings.scale;
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = UnitSettingsParser.createSettings(settings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new UnitSettings(parsedSettings);
  }
}
